/** Voľba jazykov a kurzov ako tlačidlá („SK EN DE“, „SKI SNB“) - rovnaký
 *  vzhľad v rezervácii inštruktora, v jeho karte aj pri úprave. */
export interface ChipOption {
  id: number
  label: string
  /** Farba zvoleného tlačidla (kurz má farbu z číselníka). */
  color?: string
  /** Celý názov pri podržaní myši („slovenský“ pri „SK“). */
  title?: string
}

const ACTIVE = 'rounded border border-brand-500 bg-brand-500 px-2 py-1 text-xs font-medium text-white'
const INACTIVE = 'rounded border border-slate-300 bg-white px-2 py-1 text-xs text-slate-600 hover:bg-slate-50'

export function ChipGroup({
  options,
  value,
  onChange,
}: {
  options: ChipOption[]
  value: number[]
  onChange: (next: number[]) => void
}) {
  return (
    <div className="flex flex-wrap gap-1">
      {options.map((option) => {
        const active = value.includes(option.id)
        return (
          <button
            key={option.id}
            type="button"
            title={option.title}
            aria-pressed={active}
            onClick={() =>
              onChange(active ? value.filter((v) => v !== option.id) : [...value, option.id])
            }
            className={active ? ACTIVE : INACTIVE}
            style={active && option.color ? { backgroundColor: option.color, borderColor: option.color } : undefined}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}

/** Len na čítanie - zvolené položky v tom istom vzhľade. */
export function Chips({ options, value }: { options: ChipOption[]; value: number[] }) {
  const selected = options.filter((option) => value.includes(option.id))
  if (!selected.length) return <span className="text-slate-400">—</span>
  return (
    <div className="flex flex-wrap gap-1">
      {selected.map((option) => (
        <span
          key={option.id}
          title={option.title}
          className={ACTIVE.replace('px-2 py-1', 'px-1.5 py-0.5')}
          style={option.color ? { backgroundColor: option.color, borderColor: option.color } : undefined}
        >
          {option.label}
        </span>
      ))}
    </div>
  )
}

/** Možnosti z číselníkov - jazyky bez farby, kurzy s farbou. */
export function languageChips(rows: Array<{ id: number; key?: string | null; name?: string | null; use?: boolean | null }>) {
  return rows.map((l) => ({ id: l.id, label: l.key ?? '', title: l.name ?? undefined }))
}

export function courseChips(rows: Array<{ id: number; key?: string | null; name?: string | null; color?: string | null }>) {
  return rows.map((c) => ({ id: c.id, label: c.key ?? '', color: c.color ?? undefined, title: c.name ?? undefined }))
}
